var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "integralUser seller-style" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "/" } },
        [
          _c(
            "el-breadcrumb-item",
            {
              staticClass: "f18 lin-25",
              attrs: { to: { path: "/mj/groupBuying" } }
            },
            [_vm._v("拼单列表")]
          ),
          _c("el-breadcrumb-item", { staticClass: "f18 lin-25" }, [
            _vm._v("订单汇总")
          ])
        ],
        1
      ),
      _c("div", { staticClass: "box30" }),
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "flex flex1 items-center mar20-b" },
            [
              _c("el-input", {
                staticClass: "w210 mar20_r",
                attrs: { placeholder: "请输入订单编号" },
                model: {
                  value: _vm.searchForm.orderId,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.searchForm,
                      "orderId",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "searchForm.orderId"
                }
              }),
              _c("el-input", {
                staticClass: "w210 mar20_r",
                attrs: { placeholder: "请输入买家" },
                model: {
                  value: _vm.searchForm.buyerName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.searchForm,
                      "buyerName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "searchForm.buyerName"
                }
              }),
              _c("el-input", {
                staticClass: "w210 mar20_r",
                attrs: { placeholder: "请输入所属上级" },
                model: {
                  value: _vm.searchForm.regimentalCommanderName,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.searchForm,
                      "regimentalCommanderName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "searchForm.regimentalCommanderName"
                }
              }),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.searchList } },
                [_vm._v("查询")]
              ),
              _c("el-button", { on: { click: _vm.restList } }, [
                _vm._v("重置")
              ]),
              _c("el-button", { on: { click: _vm.exportList } }, [
                _vm._v("导出")
              ])
            ],
            1
          ),
          _vm.orderCollect.orderCount
            ? _c(
                "div",
                { staticClass: "flex flex-wrap" },
                [
                  _c("div", { staticClass: "pad10-b mar20-r" }, [
                    _vm._v("订单数：" + _vm._s(_vm.orderCollect.orderCount))
                  ]),
                  _vm._l(_vm.orderCollect.goodsCountList, function(item) {
                    return _c(
                      "div",
                      { key: item.goodsName, staticClass: "mar20-r pad10-b" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(item.goodsName) +
                            "商品数量：" +
                            _vm._s(item.goodsTotalCount) +
                            _vm._s(item.unit) +
                            "\n      "
                        )
                      ]
                    )
                  }),
                  _c("div", { staticClass: "pad10-b" }, [
                    _vm._v("总金额：￥" + _vm._s(_vm.orderCollect.totalAmount))
                  ])
                ],
                2
              )
            : _vm._e(),
          _c(
            "el-table",
            {
              attrs: { border: "", data: _vm.list, "row-class-name": "pointer" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "orderId",
                  label: "订单号",
                  "min-width": "12%"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  "show-overflow-tooltip": "",
                  prop: "name",
                  label: "商品信息",
                  "min-width": "15%"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _vm._l(scope.row.goodsDetailList, function(
                        item,
                        index
                      ) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            _vm._s(item.goodsName) +
                              "*" +
                              _vm._s(item.goodsQuantity)
                          )
                        ])
                      })
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "linkman", label: "收货人", "min-width": "10%" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "receiveAddress",
                  label: "收货地址",
                  "min-width": "15%"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "联系方式", "min-width": "10%" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderTimeStr",
                  label: "下单时间",
                  "min-width": "15%"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "buyerName", label: "买家", "min-width": "10%" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "regimentalCommanderName",
                  label: "所属上级",
                  "min-width": "10%"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalPrice",
                  label: "总金额(￥)",
                  "min-width": "10%"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "memo", label: "买家留言", "min-width": "15%" }
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.openGoodDetail(scope.row.orderId)
                              }
                            }
                          },
                          [_vm._v("查看商品详情")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "商品详情",
            visible: _vm.goodVisible,
            "close-on-click-modal": false,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.goodVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "pad20_b" }, [
                _vm._v("订单号：" + _vm._s(_vm.curOrderId))
              ]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.goodsList,
                    "row-key": "goodsId",
                    "max-height": "400",
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "goodsName", label: "商品名称" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goodsQuantity",
                      width: "100",
                      label: "数量"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sellFactPrice",
                      width: "100",
                      label: "单价(￥)"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "totalAmount",
                      width: "100",
                      label: "总额(￥)"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }